export default {
  body: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  heading: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  script: '\'LC Script\', \'Brush Script MT\', \'Times Italic\', \'Times New Roman\', cursive',
  primary: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  secondary: '\'Mr Eaves\', \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  tertiary: 'Roboto, \'Helvetica Neue\', Helvetica, Arial, sans-serif',
  monospace: 'Menlo, monospace',
};
